/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const CheckScheduleForEmployeeDocument = gql`
    query CheckScheduleForEmployee($companyId: Int!, $branchId: Int!, $employeeId: Int) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branchesPaginated(id: $branchId) {
        branches {
          employeesPaginated(id: $employeeId) {
            employees {
              workSchedules(companyId: $companyId) {
                id
                startDate
                endDate
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCheckScheduleForEmployeeQuery__
 *
 * To run a query within a React component, call `useCheckScheduleForEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckScheduleForEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckScheduleForEmployeeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useCheckScheduleForEmployeeQuery(baseOptions: Apollo.QueryHookOptions<CheckScheduleForEmployeeQuery, CheckScheduleForEmployeeQueryVariables> & ({ variables: CheckScheduleForEmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckScheduleForEmployeeQuery, CheckScheduleForEmployeeQueryVariables>(CheckScheduleForEmployeeDocument, options);
      }
export function useCheckScheduleForEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckScheduleForEmployeeQuery, CheckScheduleForEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckScheduleForEmployeeQuery, CheckScheduleForEmployeeQueryVariables>(CheckScheduleForEmployeeDocument, options);
        }
export function useCheckScheduleForEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckScheduleForEmployeeQuery, CheckScheduleForEmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckScheduleForEmployeeQuery, CheckScheduleForEmployeeQueryVariables>(CheckScheduleForEmployeeDocument, options);
        }
export type CheckScheduleForEmployeeQueryHookResult = ReturnType<typeof useCheckScheduleForEmployeeQuery>;
export type CheckScheduleForEmployeeLazyQueryHookResult = ReturnType<typeof useCheckScheduleForEmployeeLazyQuery>;
export type CheckScheduleForEmployeeSuspenseQueryHookResult = ReturnType<typeof useCheckScheduleForEmployeeSuspenseQuery>;
export type CheckScheduleForEmployeeQueryResult = Apollo.QueryResult<CheckScheduleForEmployeeQuery, CheckScheduleForEmployeeQueryVariables>;
export const CheckServicesDocument = gql`
    query CheckServices($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      servicesList(deleted: false) {
        id
      }
    }
  }
}
    `;

/**
 * __useCheckServicesQuery__
 *
 * To run a query within a React component, call `useCheckServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckServicesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCheckServicesQuery(baseOptions: Apollo.QueryHookOptions<CheckServicesQuery, CheckServicesQueryVariables> & ({ variables: CheckServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckServicesQuery, CheckServicesQueryVariables>(CheckServicesDocument, options);
      }
export function useCheckServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckServicesQuery, CheckServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckServicesQuery, CheckServicesQueryVariables>(CheckServicesDocument, options);
        }
export function useCheckServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckServicesQuery, CheckServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckServicesQuery, CheckServicesQueryVariables>(CheckServicesDocument, options);
        }
export type CheckServicesQueryHookResult = ReturnType<typeof useCheckServicesQuery>;
export type CheckServicesLazyQueryHookResult = ReturnType<typeof useCheckServicesLazyQuery>;
export type CheckServicesSuspenseQueryHookResult = ReturnType<typeof useCheckServicesSuspenseQuery>;
export type CheckServicesQueryResult = Apollo.QueryResult<CheckServicesQuery, CheckServicesQueryVariables>;
export const CheckProductsDocument = gql`
    query CheckProducts($companyId: Int!, $branchId: Int!) {
  products(companyId: $companyId, branchId: $branchId) {
    items {
      id
    }
  }
}
    `;

/**
 * __useCheckProductsQuery__
 *
 * To run a query within a React component, call `useCheckProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckProductsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useCheckProductsQuery(baseOptions: Apollo.QueryHookOptions<CheckProductsQuery, CheckProductsQueryVariables> & ({ variables: CheckProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckProductsQuery, CheckProductsQueryVariables>(CheckProductsDocument, options);
      }
export function useCheckProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckProductsQuery, CheckProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckProductsQuery, CheckProductsQueryVariables>(CheckProductsDocument, options);
        }
export function useCheckProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckProductsQuery, CheckProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckProductsQuery, CheckProductsQueryVariables>(CheckProductsDocument, options);
        }
export type CheckProductsQueryHookResult = ReturnType<typeof useCheckProductsQuery>;
export type CheckProductsLazyQueryHookResult = ReturnType<typeof useCheckProductsLazyQuery>;
export type CheckProductsSuspenseQueryHookResult = ReturnType<typeof useCheckProductsSuspenseQuery>;
export type CheckProductsQueryResult = Apollo.QueryResult<CheckProductsQuery, CheckProductsQueryVariables>;
export type CheckScheduleForEmployeeQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  employeeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CheckScheduleForEmployeeQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', employeesPaginated?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', workSchedules?: Array<{ __typename?: 'WorkScheduleProxy', id: number, startDate: string, endDate: string }> | null }> | null } | null }> | null } | null } | null } | null };

export type CheckServicesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type CheckServicesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', servicesList?: Array<{ __typename?: 'ServiceProxy', id: number }> | null } | null } | null };

export type CheckProductsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type CheckProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPaginated', items?: Array<{ __typename?: 'ProductProxy', id: number }> | null } | null };
